var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',[_c('md-card-content',[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_vm._t("title"),_vm._t("sub-title")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }